import axios from 'axios'
import _URL from '../../URL/index';
const limit = 15

export default {
    services: {
        getCountries: () => {
            return axios.get(`${_URL._API}/countries`);
        },
        autocompleteLocations: (input, type, country_code = "") => {
            if (["airport", "arrival", "departure"].indexOf(type) > -1) {
                return axios.get(`${_URL._API}/airports?input=${input}&type=airport&country_code=${country_code}`);
            } else {
                return axios.get(`${_URL._API}/locations?input=${input}&country_code=${country_code}`);
            }
        },
        getCities: (input) => {
            return axios.get(`${_URL._API}/cities?input=${input}`);
        }
    }
}